export class User {
  id: number;
  active: boolean;
  system: boolean;
  login: string;
  name: string;
  companyName: string;
  email: string;
  telephone: string;
  checked: boolean;
}

export class Role {
  id: number;
  name: string;
}
